import {ENDPOINTS_EMPLOYEE, ENDPOINTS_MANAGER} from 'common/endpoints/vacations-absences.endpoints';

class RequestFormService {

  constructor($http, $log) {
    'ngInject';
    this.http = $http;
    this.log = $log;
  }

  create(employeeId, data, isInception, managerId) {
    this.log.info('RequestFormService.create:', employeeId, data, isInception, managerId);
    if (isInception) {
      return this.http.post(ENDPOINTS_MANAGER.post.request(employeeId, managerId), data);
    }
    return this.http.post(ENDPOINTS_EMPLOYEE.post.request(employeeId), data);
  }

  createSickLeaveReports(employeeId, sickLeaveReports, isInception, managerId) {
    const data = {sickLeaveReports};
    this.log.info('RequestFormService.createSickLeaveReports:', employeeId, data, isInception, managerId);
    if (isInception) {
      return this.http.post(ENDPOINTS_MANAGER.post.medicalParts(employeeId, managerId), data);
    }
    return this.http.post(ENDPOINTS_EMPLOYEE.post.medicalParts(employeeId), data);
  }

  update(employeeId, data, isInception, managerId) {
    this.log.info('RequestFormService.update:', employeeId, data, isInception, managerId);
    if (isInception) {
      return this.http.put(ENDPOINTS_MANAGER.put.request(employeeId, managerId), data);
    }
    return this.http.put(ENDPOINTS_EMPLOYEE.put.request(employeeId), data);
  }

  updateSicknessWhenNo(employeeId, data, isInception, managerId) {
    this.log.info('RequestFormService.updateSicknessWhenNo:', employeeId, data, isInception, managerId);
    if (isInception) {
      return this.http.put(ENDPOINTS_MANAGER.put.discharge(employeeId, managerId), data);
    }
    return this.http.put(ENDPOINTS_EMPLOYEE.put.discharge(employeeId), data);
  }

  getRelapses(employeeId, isInception, managerId) {
    this.log.info('RequestFormService.getRelapses:', employeeId, isInception, managerId);
    if (isInception) {
      return this.http.get(ENDPOINTS_MANAGER.get.relapses(employeeId, managerId));
    }
    return this.http.get(ENDPOINTS_EMPLOYEE.get.relapses(employeeId));
  }
}

export default RequestFormService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestForm.service.js